import React, { useEffect, useState } from "react"
import {
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react"
import { Spin } from "antd"
import { useDispatch } from "react-redux"
import dayjs from "dayjs"
import { getLockerRent } from "src/store/Slices/Administrator/LockersSlice"

const LABELS = {
  id: "№",
  lockerId: "Шкафчик",
  lockerNumber: "Номер",
  clubId: "Клуб",
  clubName: "Клуб",
  userId: "Клиент",
  userPhone: "Телефон",
  startDate: "Начало",
  endDate: "Окончание",
  status: "Статус",
  price: "Цена",
  isReleased: "Сдана",
  isDeleted: "Удалена",
  dateCreate: "Создана",
  error: "Ошибка",
}

const ORDER = [
  "id",
  "lockerId",
  "lockerNumber",
  "clubName",
  "clubId",
  "userId",
  "userPhone",
  "startDate",
  "endDate",
  "status",
  "price",
  "isReleased",
  "error",
  "dateCreate",
  "isDeleted",
]

const formatValue = (key, value) => {
  if (value == null || value === "") return "—"
  if (typeof value === "boolean") return value ? "Да" : "Нет"
  if (
    typeof value === "string" &&
    /date|Date/.test(key) &&
    dayjs(value).isValid()
  ) {
    return dayjs(value).format("DD.MM.YYYY HH:mm")
  }
  if (typeof value === "object") return JSON.stringify(value)
  return String(value)
}

const LockerRentDetailsModal = ({ visible, rentId, onClose }) => {
  const dispatch = useDispatch()
  const [details, setDetails] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!visible || !rentId) return
    setDetails(null)
    setLoading(true)
    dispatch(getLockerRent(rentId)).then((result) => {
      setLoading(false)
      const payload = result.payload
      if (!payload || payload.response) return
      setDetails(payload?.data?.value ?? payload?.value ?? payload)
    })
  }, [visible, rentId])

  const entries = details && typeof details === "object" ? Object.keys(details) : []
  const keys = [
    ...ORDER.filter((key) => entries.includes(key)),
    ...entries.filter((key) => !ORDER.includes(key)),
  ]

  return (
    <CModal alignment='center' visible={visible} onClose={onClose} size='lg'>
      <CModalHeader>
        <CModalTitle>Аренда №{rentId}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        {loading ? (
          <div style={{ textAlign: "center", padding: 24 }}>
            <Spin />
          </div>
        ) : (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "180px 1fr",
              rowGap: 10,
              columnGap: 12,
            }}
          >
            {keys.map((key) => (
              <React.Fragment key={key}>
                <div style={{ color: "#6c757d" }}>{LABELS[key] || key}</div>
                <div>{formatValue(key, details[key])}</div>
              </React.Fragment>
            ))}
          </div>
        )}
      </CModalBody>
    </CModal>
  )
}

export default LockerRentDetailsModal
